<script type="text/ecmascript-6">

export default {
  props: {
    fieldName: {
      type: String
    },
    translations: {
      type: Object
    },
    availableLanguageCodes: {
      type: Array,
      default() {
        return [];
      }
    },
    defaultLanguageCode: {
      type: String,
      default: 'de_DE'
    },
    placeholder: String,
    defaultRequired: {
      type: Boolean,
      default: false
    },
    textField: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    defaultLanguageValueChanged: function (event) {
      if (event.target.dataset.languageCode === this.defaultLanguageCode) {
        this.$emit('default-language-value-changed', event.target.value);
      }
    }
  }
}
</script>
<style scoped>
  .flex {
    display: flex;
  }

  .text-area-lang-info {
    width: 18%;
  }
</style>
<template>
  <div>
    <div
        :class="{'input-group': availableLanguageCodes.length > 1, 'flex': textField}"
         class="component-multilang-text-input bootstrap-touchspin">

      <textarea v-if="textField"
                :placeholder="placeholder"
                v-model="translations[availableLanguageCodes[0]]"
                @change="defaultLanguageValueChanged"
                v-bind:data-language-code="availableLanguageCodes[0]"
                class="touchspin2 form-control"
                style="width: 95%"
                v-bind:required="defaultRequired">
      </textarea>
      <input
          v-else
          :placeholder="placeholder"
          v-model="translations[availableLanguageCodes[0]]"
          @change="defaultLanguageValueChanged"
          v-bind:data-language-code="availableLanguageCodes[0]"
          type="text"
          class="touchspin2 form-control"
          style="display: block;"
          v-bind:required="defaultRequired"
      >

      <span v-if="availableLanguageCodes.length > 1" class="input-group-btn">
                <button
                    type="button"
                    class="btn btn-white bootstrap-touchspin-up"
                    data-toggle="modal"
                    :class="{'full-height': textField}"
                    :data-target="'#nameModal'+fieldName">
                    <i class="fa fa-language"></i>
                </button>
            </span>
    </div>

    <div v-if="availableLanguageCodes.length > 1" class="modal inmodal" :id="'nameModal'+fieldName" tabindex="-1"
         role="dialog" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content animated fadeInDown">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              <span aria-hidden="true">&times;</span>
              <span class="sr-only">Close</span>
            </button>
            <h4 class="modal-title">Translations</h4>
            <small>For the field: <strong v-text="fieldName"></strong></small>
          </div>
          <div class="modal-body">
            <form role="form">
              <div class="form-group">
                <template v-for="code in availableLanguageCodes">
                  <div class="input-group" :class="{'flex': textField}">
                    <textarea v-if="textField"
                              :placeholder="placeholder"
                              v-model="translations[code]"
                              @change="defaultLanguageValueChanged"
                              v-bind:data-language-code="code"
                              class="form-control"
                              v-bind:required="defaultRequired && code === defaultLanguageCode">
                    </textarea>
                    <input
                        v-else
                        v-model="translations[code]"
                        @change="defaultLanguageValueChanged"
                        v-bind:data-language-code="code"
                        type="text"
                        class="form-control translation"
                        v-bind:required="defaultRequired && code === defaultLanguageCode">
                    <span class="input-group-addon" :class="{'text-area-lang-info' : textField}">{{ code }}&nbsp;&nbsp;<i class="fa fa-language"></i></span>
                  </div>
                  <br/>
                </template>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary"
                    data-dismiss="modal">Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
